import { Expose } from 'class-transformer';
import { BookedStatusEnum } from '../../../../store/events/eventTypes';

export class EventParticipantModel {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'event_id' })
  eventId: string;
  @Expose({ name: 'user_id' })
  userId: string;
  @Expose({ name: 'status' })
  status: BookedStatusEnum;
  @Expose({ name: 'is_attended' })
  isAttended: boolean;
}
